/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit, Output,
} from '@angular/core';
import {CrmIssue} from 'compob2b-libs';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-issue-due-date',
    templateUrl: './issue-due-date.component.html',
    styleUrls: ['./issue-due-date.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IssueDueDateComponent implements OnInit {
  @Input() issue: CrmIssue;
  @Output() updateDueDateEvent = new EventEmitter<Date>();

  focusInput = false;
  inputControl: FormControl;

  ngOnInit(): void {
    this.inputControl = new FormControl(null === this.issue.dueDate ? null : new Date(this.issue.dueDate));
  }

  showDateInput() {
    this.focusInput = true;
  }

  updateDueDate() {
    if (null !== this.inputControl.value) {
      this.focusInput = false;
      if (this.inputControl.value !== this.issue.dueDate) {
        this.updateDueDateEvent.emit(this.inputControl.value);
      }
    }
  }

  focusChange($event: boolean) {
    if (!$event) {
      this.focusInput = false;
    }
  }
}
